import { reduce, some, isEqual } from 'lodash-es';

export const entriesTypes = {
  adUnitMrect: /^mrect-ad-unit/,
  adUnitMrectRepeatable: /^mrect-ad-unit-repeatable/,
  adUnitSpot: /^ad-unit-spot/,
  adUnitVideo: /^sponsoredvideo-ad-unit/,
  excoPlayerUnit: /^exco-player-unit/,
  adUnitHighImpact: /^high-impact-ad-unit/,
  articleGroup: /article-group/,
  calculators: /calculators/,
  columnList: /column-list/,
  container: /^container/,
  contentCol: /^content-col/,
  contentList: /content-list/,
  edHighImpact: /editorial-high-impact/,
  externalContent: /external-content/,
  featureGrid: /feature-grid/,
  html: /^html/,
  inlineContentAd: /inline-content-ad/,
  marketplaceList: /marketplace-list/,
  photo: /^photo/,
  rightRailCol: /^right-rail/,
  reviewsDropdowns: /reviews-dropdowns/,
  table: /^table/,
  tcoDropdowns: /tco-dropdowns/,
  video: /^video/,
  verticalVideo: /^vertical-video/,
  vinDecoder: /^vin-decoder$/,
  faq: /^faq/,
  infoGraphic: /info-graphic/,
  shoppingLink: /^shopping-link/,
  evQuiz: /^ev-quiz/,
};

/**
 * @param {Object} objOfTypes
 * @param {Array} entriesToAvoid - array of regExp that shoul be removed
 * @return {Array}
 */
export const getFilteredRegExpArr = (objOfTypes, entriesToAvoid) =>
  reduce(
    objOfTypes,
    (accum, value) => {
      if (!some(entriesToAvoid, item => isEqual(item, value))) {
        accum.push(value);
      }
      return accum;
    },
    []
  );
